// src/components/store/sections/faqs/FaqV26AccordioncleanCrimsonRose.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV26AccordioncleanCrimsonRose(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={26}
      archKey="accordion_clean"
      archLabel="Clean Emerald Accordion"
      palName="CrimsonRose"
      grad="from-rose-500 via-pink-600 to-red-600"
      lightBg="bg-rose-50"
      textCol="text-rose-700"
      borderCol="border-rose-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f43f5e"
      {...props}
    />
  );
}
